


























































import Vue, { Component } from 'vue';
import { ELanguage } from '@ringana/configs';
import Modal from '../modal/Modal.vue';
import EventListenerHelper from '../../../helpers/EventListenerHelper';
import CodeBasedVoucherAssignment from './CodeBasedVoucherAssignment.vue';
import { IVoucherAssignmentCustomerData } from '../../../common/interfaces/shared.interface';
import VoucherAssignmentSuccessfulNotice from './VoucherAssignmentSuccessfulNotice.vue';
import VoucherAssignmentMessageTemplate from './VoucherAssignmentMessageTemplate.vue';
import { IAssignableVoucherInfo } from '../../../common/interfaces/vouchers.interface';
import CustomerBasedVoucherAssignment from './CustomerBasedVoucherAssignment.vue';
import CookieHelper from '../../../helpers/CookieHelper';
import ApplicationError from '../../../errors/application-error';
import LoadingSpinner from '../loading/LoadingSpinner.vue';
import NotificationHelper from '../../../helpers/NotificationHelper';
import { ESwalType } from '../../../common/enums/index.enum';
import VoucherAssignmentMailSentNotification from './VoucherAssignmentMailSentNotification.vue';

interface IAssignVoucherPopupComponent {
  $refs?: IAssignVoucherPopupRefs;
  assignmentLoading: boolean;
  assignmentDone: boolean;
  availableVouchers: IAssignableVoucherInfo[];
  emailSent: boolean;
  sendEmailLoading: boolean;
  showAssignmentError: boolean;
  showTemplate: boolean;
  targetCustomerData: IVoucherAssignmentCustomerData | null;
  voucherCodeToAssign: string;
  voucherValue: number;
}

interface IAssignVoucherPopupRefs {
  modal: Component & {
    closeModal(): void;
    openModal(): void;
  };
}

export default Vue.extend({
  components: {
    CodeBasedVoucherAssignment,
    CustomerBasedVoucherAssignment,
    LoadingSpinner,
    Modal,
    VoucherAssignmentMailSentNotification,
    VoucherAssignmentMessageTemplate,
    VoucherAssignmentSuccessfulNotice,
  },
  data(): IAssignVoucherPopupComponent {
    return {
      assignmentDone: false,
      assignmentLoading: false,
      availableVouchers: [],
      emailSent: false,
      sendEmailLoading: false,
      showAssignmentError: false,
      showTemplate: false,
      targetCustomerData: null,
      voucherCodeToAssign: ``,
      voucherValue: 0,
    };
  },
  computed: {
    lang(): ELanguage {
      return CookieHelper.getLanguage();
    },
  },
  created(): void {
    EventListenerHelper.setUpEventListeners([
      { callback: this.openAssignVoucherPopup, name: `salestool-assign-voucher` },
      { callback: this.openAssignVoucherPopup, name: `datasheet-assign-voucher` },
    ]);
  },
  methods: {
    async assignVoucher(identifier: number | string, mode: `codeBased` | `customerBased`): Promise<void> {
      this.assignmentLoading = true;
      this.showAssignmentError = false;
      if(mode === `codeBased`) {
        this.targetCustomerData = await this.$zApiService.getCustomer(identifier as number);
      } else {
        this.voucherCodeToAssign = identifier as string;
      }
      if(this.targetCustomerData) {
        try {
          const result = await this.$cartApiService.assignVoucherToDownlineCustomer(this.targetCustomerData.customerNumber, this.voucherCodeToAssign);
          if(mode === `codeBased`) {
            document.dispatchEvent(new CustomEvent<{ vouchers: IAssignableVoucherInfo[] }>(`salestool-assignable-vouchers-fetched`, { detail: { vouchers: result } }));
          }
        } catch (err) {
          this.showAssignmentError = true;
          this.assignmentLoading = false;
          if(mode === `codeBased`) {
            this.targetCustomerData = null;
          } else {
            this.voucherCodeToAssign = ``;
          }
          return;
        }
        this.assignmentLoading = false;
        this.assignmentDone = true;
      } else {
        throw new ApplicationError(`targetCustomerData not available`);
      }
    },
    async closePopup(): Promise<void> {
      this.$refs.modal.closeModal();
      const result = await this.$cartApiService.getVouchersAssignableToDownline();
      document.dispatchEvent(new CustomEvent<{ vouchers: IAssignableVoucherInfo[] }>(`salestool-assignable-vouchers-fetched`, { detail: { vouchers: result } }));
    },
    async openAssignVoucherPopup(event: CustomEvent<{ code?: string; customerNumber?: number; value?: number }>): Promise<void> {
      this.assignmentDone = false;
      this.availableVouchers = [];
      this.emailSent = false;
      this.showAssignmentError = false;
      this.showTemplate = false;
      this.targetCustomerData = null;
      this.voucherCodeToAssign = ``;
      this.voucherValue = 0;
      const { code, customerNumber, value } = event.detail;
      if(customerNumber) {
        try {
          this.targetCustomerData = await this.$zApiService.getCustomer(customerNumber);
          this.availableVouchers = (await this.$cartApiService.getVouchersAssignableToDownline()).filter(voucher => !voucher.customerNumber);
        } catch (err) {
          await NotificationHelper.showAwaitableSwal(
            ``,
            this.$t(`header:vouchers.fetchVouchersFailed`),
            undefined,
            ESwalType.ERROR,
          );
          return;
        } finally {
          document.dispatchEvent(new CustomEvent(`datasheet-assignable-vouchers-fetched`));
        }
      } else if(code && value) {
        this.voucherCodeToAssign = code;
        this.voucherValue = value;
      } else {
        throw new ApplicationError(`Invalid voucher assignment data`);
      }
      this.$refs.modal.openModal();
    },
    redirectToBuyVouchers(): void {
      window.open(`/prints`);
      this.$refs.modal.closeModal();
    },
    async sendMail(): Promise<void> {
      if(!this.voucherCodeToAssign) {
        return;
      }
      this.sendEmailLoading = true;
      try {
        await this.$zApiService.sendVoucherAssignmentMail(this.voucherCodeToAssign);
        this.emailSent = true;
      } catch (err) {
        await NotificationHelper.showAwaitableSwal(
          ``,
          this.$t(`header:vouchers.sendMailFailed`),
          undefined,
          ESwalType.ERROR,
        );
      } finally {
        this.sendEmailLoading = false;
      }
    },
  },
});
